import { initializeApp } from "firebase/app";
import { getMessaging, onMessage } from "firebase/messaging";
import {
  FIREBASE_API_KEY,
  FIREBASE_AUTH_DOMAIN,
  FIREBASE_DATABASE_URL,
  FIREBASE_PROJECT_ID,
  FIREBASE_STORAGE_BUCKET,
  FIREBASE_MESSAGING_SENDER_ID,
  FIREBASE_APP_ID,
  FIREBASE_MEASUREMENT_ID,
  FIREBASE_VAPID_KEY
} from "./src/environment";

let messaging = {};
try {
  const firebaseConfig = {
    apiKey: FIREBASE_API_KEY,
    authDomain: FIREBASE_AUTH_DOMAIN,
    databaseURL: FIREBASE_DATABASE_URL,
    projectId: FIREBASE_PROJECT_ID,
    storageBucket: FIREBASE_STORAGE_BUCKET,
    messagingSenderId: FIREBASE_MESSAGING_SENDER_ID,
    appId: FIREBASE_APP_ID,
    measurementId: FIREBASE_MEASUREMENT_ID
  };

  const app = initializeApp(firebaseConfig);
  messaging = getMessaging(app);

  onMessage(messaging, function (payload) {
  try {  //try???
    console.log('Message received. ', payload);

    const noteTitle = payload.notification.title;
    const noteOptions = {
      body: payload.notification.body,
      icon: "typewriter.jpg", //this is my image in my public folder
    };

    console.log("title ", noteTitle);
    console.log("URL ", payload.fcmOptions.link);
    //var notification = //examples include this, seems not needed

    new Notification(noteTitle, noteOptions).onclick = function () {
      // console.log(event);
      // console.log(payload.notification.click_action);
      if(payload && payload.fcmOptions && payload.fcmOptions.link &&  payload.fcmOptions.link.length > 0)
      {
        window.open(payload.fcmOptions.link, '_blank');
      }
      setTimeout(() => {
        this.close();
      }, 1000);
    };
  }
  catch (err) {
    console.log('Caught error: ', err);
  }
});

} catch (error) {
  console.error(error);
}

// VAPID key for getToken - used in app.jsx
export const vapidKey = FIREBASE_VAPID_KEY;
export { messaging };
